import React, { FC } from 'react';

import { IPrizeMerchant } from './types';
import Default from './organisms/Default';
import Angelinas from './organisms/Angelinas';
import Miette from './organisms/Miette';
import CameronSeafood from './organisms/CameronsSeafood';

interface HeaderProps {
  merchant: IPrizeMerchant;
}

const Header: FC<HeaderProps> = ({ merchant }) => {
  switch ( merchant.prizeFilePath ) {
    case 'angelinas_of_maryland':
      return <Angelinas merchant={merchant} />;
    case 'camerons_seafood':
      return <CameronSeafood merchant={merchant} />;
    case 'miette':
      return <Miette merchant={merchant} />;
    default:
      return <Default merchant={merchant} />;
  }
};

export default Header;
